import styled, { css } from 'styled-components';
import { Color, MaxWidth } from '../../common/base';

const TeamImg = styled.div`
  display: inline-block;
  width: calc((100% / 3) - 24px);
  margin: 16px 24px;
  margin-left: 0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: all ease-in-out 0.2s;
  &:hover {
    &:before {
      content: '';
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: ${Color.redMediumDark};
      opacity: 0.4;
      z-index: 2;
    }
  }
  ${props =>
    props.activeStyle &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: ${Color.redMediumDark};
        opacity: 0.4;
        z-index: 2;
      }
    `}
  img {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    width: 100%;
    display: block;
  }
  ${MaxWidth.md`
    width: 100%;
    display: block;
    height: auto;
  `}
`;

const TeamInfoBox = styled.div`
  position: relative;
  ${props =>
    props.alignment === 'right'
      ? css`
          left: -124px;
        `
      : css`
          left: 64px;
        `}
  top: 10px;
  width: 110%;
  display: flex;
  height: 100%;
  ${MaxWidth.md`
    display: none;
  `}
`;

const TeamInfoCard = styled.div`
  background-color: ${Color.white};
  padding: 100px 60px;
`;

const TeamInfoSocial = styled.div`
  position: absolute;
  top: 0;
  right: 60px;
  img {
    margin: 0 8px;
  }
`;

const TeamSubtitle = styled.p`
  text-transform: uppercase;
  color: ${Color.blackLight};
  font-size: 12px;
`;

const TeamInfoCardMobile = styled.div`
  position: relative;
  width: calc(100% + 100% + 24px);
  left: 0;
  margin-top: 24px;
  h4 {
    padding-right: 64px;
    padding-top: 8px;
  }
  ${props =>
    props.activeStyleMobile % 2 === 1 &&
    css`
      left: calc(-100% + -28px);
      h4 {
        text-align: right;
        + p {
          text-align: right;
          + p {
            text-align: right;
          }
        }
      }
    }
  `}
`;

const TeamInfoSocialMobile = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  img {
    margin: 0 8px;
  }
  ${props =>
    props.activeStyleMobile % 2 === 1 &&
    css`
      right: 0;
    `}
`;

export {
  TeamImg,
  TeamInfoBox,
  TeamInfoCard,
  TeamInfoSocial,
  TeamSubtitle,
  TeamInfoCardMobile,
  TeamInfoSocialMobile
};
